export class ExporterPropertyBase {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // Constructor
    constructor(model) {
        this.key = model.key;
        this.title = model.title;
        this.description = model.description;
        this.category = model.category;
        this.dependsOn = model.dependsOn;
        this.type = model.type;
    }
}
